/**
****************************************************************************************
Project: Readabl
File: index.js
Description: This is the main file in which main app is wrapped by redux, routing and error boundary.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore from './redux/store/store';
import ErrorBoundary from "./container/ErrorBoundary";
import {
  BrowserRouter,
} from "react-router-dom";
import * as c from "./utils/constants/constants";

const store = configureStore();

if (typeof window !== "undefined") {
  const resizeObserverErr = "ResizeObserver loop completed with undelivered notifications.";
  const resizeObserverErr2 = "ResizeObserver loop limit exceeded";

  const errorHandler = (e) => {
    if (e.message === resizeObserverErr || e.message === resizeObserverErr2) {
      e.stopImmediatePropagation();
    }
  };
  window.addEventListener("error", errorHandler);
}



ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();